export interface BoardForm {
  name: string;
  actual: boolean;
  colorHeaderBg: string;
  colorDotBg: string;
  colorNameColor: string;
  colorCntBg: string;
  colorCntColor: string;
}

export const EMPTY_BOARD_FORM: BoardForm = {
  name: '',
  actual: true,
  colorHeaderBg: '#FFF3E0',
  colorDotBg: '#FF9800',
  colorNameColor: '#E65100',
  colorCntBg: '#FFE0B2',
  colorCntColor: '#E65100',
};

export const COLOR_PRESETS: { label: string; dot: string; values: Omit<BoardForm, 'name' | 'order' | 'actual'> }[] = [
  { label: 'Оранжевый',  dot: '#FF9800', values: { colorHeaderBg: '#FFF3E0', colorDotBg: '#FF9800', colorNameColor: '#E65100', colorCntBg: '#FFE0B2', colorCntColor: '#E65100' } },
  { label: 'Синий',      dot: '#2196F3', values: { colorHeaderBg: '#E3F2FD', colorDotBg: '#2196F3', colorNameColor: '#0D47A1', colorCntBg: '#BBDEFB', colorCntColor: '#0D47A1' } },
  { label: 'Зелёный',    dot: '#4CAF50', values: { colorHeaderBg: '#E8F5E9', colorDotBg: '#4CAF50', colorNameColor: '#1B5E20', colorCntBg: '#C8E6C9', colorCntColor: '#1B5E20' } },
  { label: 'Фиолетовый', dot: '#9C27B0', values: { colorHeaderBg: '#F3E5F5', colorDotBg: '#9C27B0', colorNameColor: '#6A1B9A', colorCntBg: '#E1BEE7', colorCntColor: '#6A1B9A' } },
  { label: 'Бирюзовый',  dot: '#009688', values: { colorHeaderBg: '#E0F2F1', colorDotBg: '#009688', colorNameColor: '#004D40', colorCntBg: '#B2DFDB', colorCntColor: '#004D40' } },
  { label: 'Красный',    dot: '#F44336', values: { colorHeaderBg: '#FFEBEE', colorDotBg: '#F44336', colorNameColor: '#B71C1C', colorCntBg: '#FFCDD2', colorCntColor: '#B71C1C' } },
  { label: 'Жёлтый',    dot: '#FFC107', values: { colorHeaderBg: '#FFF8E1', colorDotBg: '#FFC107', colorNameColor: '#F57F17', colorCntBg: '#FFECB3', colorCntColor: '#F57F17' } },
  { label: 'Серый',      dot: '#9E9E9E', values: { colorHeaderBg: '#F5F5F5', colorDotBg: '#9E9E9E', colorNameColor: '#424242', colorCntBg: '#EEEEEE', colorCntColor: '#616161' } },
];
